import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { Img } from '../Img/Img.js';
const ICON_VERSION_MAP = {
    'bg-white': 'color',
    transparent: 'white',
};
const SVG_COLOR = {
    'bg-white': 'text-primary-main',
    transparent: 'text-white',
};
export const renderImage = (bgColor, image, size) => {
    const img = image?.src
        ? image
        : {
            icon: image?.icon || 'LogoIcon',
            iconVersion: ICON_VERSION_MAP[bgColor],
        };
    return (_jsx(Img, { image: img, className: SVG_COLOR[bgColor], width: size?.width, height: size?.height }));
};
//# sourceMappingURL=renderImage.js.map